import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LOGO_URL } from "../lib/constants";
import { toast } from "sonner";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@griansolarpower.au");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/app"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/app");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src="https://images.unsplash.com/photo-1770567764570-ebe9b5d0c02b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
          alt="Solar home" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-secondary/70" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <h2 className="text-4xl font-head font-extrabold tracking-tight leading-tight">Solar Sales, Streamlined.</h2>
          <p className="mt-3 text-white/80 max-w-md">Manage leads, quotes, rebates and your entire pipeline from one place — built for the Australian solar market.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 bg-background">
        <form onSubmit={submit} className="w-full max-w-sm animate-fade-up" data-testid="login-form">
          <img src={LOGO_URL} alt="Grian Solar Power" className="h-14 mb-8" />
          <h1 className="text-2xl font-head font-extrabold tracking-tight">Sign in</h1>
          <p className="text-muted-foreground text-sm mt-1 mb-6">Access your Grian Solar CRM</p>
          <label className="label-caps">Email</label>
          <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full mt-1 mb-4 px-3 py-2.5 rounded-md border border-input bg-card focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none" required />
          <label className="label-caps">Password</label>
          <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full mt-1 mb-6 px-3 py-2.5 rounded-md border border-input bg-card focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none" required />
          <button data-testid="login-submit" disabled={loading}
            className="w-full py-2.5 rounded-md bg-primary text-primary-foreground font-semibold hover:-translate-y-[1px] hover:brightness-110 transition-all duration-200 disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
